let routes

if (GLOBAL_ENV.TYPE === 'server') {
  routes = require('./routes.ssr')
} else {
  routes = require('./routes.app')
}

module.exports = routes



// WEBPACK FOOTER //
// ./src/pages/routes.js